import React, { useContext } from 'react';
import { TabContext } from './Tabs';
import styles from './Tabs.module.scss';

export function TabContent(props: { name: string; children: React.ReactNode }) {
  const { name, children } = props;
  const tabContext = useContext(TabContext);

  return tabContext.activeTab === name ? (
    <div className={styles.tabContent}>{children}</div>
  ) : null;
}
